function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M166 332h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15zM166 392h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.606 84.394l-80-80A14.996 14.996 0 00417 0H15C6.716 0 0 6.716 0 15v482c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V95c0-3.979-1.581-7.794-4.394-10.606zM121 30h210v100H121V30zm270 452H121V272h270v210zm91 0h-61V257c0-8.284-6.716-15-15-15H106c-8.284 0-15 6.716-15 15v225H30V30h61v115c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V30h49.787L482 101.213V482z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166 452h180c8.284 0 15-6.716 15-15s-6.716-15-15-15H166c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
})));